import { render } from "./AppToggleSwitch.vue?vue&type=template&id=decf5774&scoped=true&ts=true"
import script from "./AppToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./AppToggleSwitch.vue?vue&type=script&lang=ts"

import "./AppToggleSwitch.vue?vue&type=style&index=0&id=decf5774&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-decf5774"]])

export default __exports__